import React from "react";
import T from "prop-types";
import { connect } from "react-redux";
import {
  cancelCustomerRma,
  cancelVendorRma
} from "MODULES/RMAsAndWarranties/actions";
import { DropDownItem } from "MODULES/shared/components";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import { toggleSwitch, renderIf } from "MODULES/shared/decorators";
import { TYPE } from "APP_ROOT/constants";
import withRma from "../../../decorators/withRma";
import RequestPartialCreditForm from "./RequestPartialCreditForm";

const RequestPartialCredit = ({ visible, open, close, rma }) => (
  <React.Fragment>
    <DropDownItem onClick={open}>
      <i className="fa fa-fw fa-ban" />
      &nbsp;Request Partial Credit
    </DropDownItem>
    <Modal open={visible} close={close}>
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Request Partial Credit</h4>
      </Header>
      <RequestPartialCreditForm rma={rma} close={close} />
    </Modal>
  </React.Fragment>
);

RequestPartialCredit.propTypes = {
  rma: T.instanceOf(Map).isRequired,
  visible: T.bool.isRequired,
  open: T.func.isRequired,
  close: T.func.isRequired
};

const connectedAction = connect(undefined, (dispatch, ownProps) => ({
  cancel: () => {
    const cancel =
      ownProps.rma.get(TYPE) === "VendorRma"
        ? cancelVendorRma
        : cancelCustomerRma;
    return dispatch(cancel());
  }
}))(RequestPartialCredit);

export default withRma(
  toggleSwitch("visible")(
    renderIf(({ rma }) => rma.get(TYPE) === "VendorRma")(connectedAction)
  )
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Actions/RequestPartialCredit.jsx